import React from "react";

interface IArrowProps {
	className?: string;
	style?: React.CSSProperties;
}

export const Arrow = ({ className, style }: IArrowProps) => {
	return (
		<svg viewBox="0 0 8 12" xmlns="http://www.w3.org/2000/svg" className={className} style={style}>
			<path d="M1.17019 1.00005C0.983936 1.18741 0.879394 1.44087 0.879394 1.70505C0.879394 1.96924 0.983936 2.22269 1.17019 2.41005L4.71019 6.00005L1.17019 9.54005C0.983936 9.72741 0.879394 9.98087 0.879394 10.2451C0.879394 10.5092 0.983936 10.7627 1.17019 10.9501C1.26315 11.0438 1.37375 11.1182 1.49561 11.1689C1.61747 11.2197 1.74818 11.2458 1.88019 11.2458C2.0122 11.2458 2.1429 11.2197 2.26476 11.1689C2.38662 11.1182 2.49722 11.0438 2.59019 10.9501L6.83019 6.71005C6.92392 6.61709 6.99831 6.50649 7.04908 6.38463C7.09985 6.26277 7.12598 6.13206 7.12598 6.00005C7.12598 5.86804 7.09985 5.73733 7.04908 5.61547C6.99831 5.49362 6.92392 5.38301 6.83019 5.29005L2.59019 1.00005C2.49722 0.906323 2.38662 0.831929 2.26476 0.78116C2.1429 0.730391 2.0122 0.704252 1.88019 0.704252C1.74817 0.704252 1.61747 0.730391 1.49561 0.78116C1.37375 0.831929 1.26315 0.906323 1.17019 1.00005Z" />
		</svg>
	);
};
